import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Link, NavLink } from 'react-router-dom';
import { Theme } from '../../config/theme';

import UserImage from './../UserImage';
import Profile from './components/Profile';

export default class UserMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
  }
  getUserImage() {
    const user = this.props.user;

    if (user.image_url && user.image_url.length > 10) {
      return user.image_url;
    }

    if (user.profile_photo && user.profile_photo.length > 10) {
      return user.profile_photo;
    }

    return '/images/default_profile.jpg';
  }

  getDogImage(dog) {
    if (dog.image_url && dog.image_url.length > 10) {
      return dog.image_url;
    }

    if (dog.profile_photo && dog.profile_photo.length > 10) {
      return dog.profile_photo;
    }

    return '/images/default_dog.jpg';
  }

  getHasDogs() {
    const dogs = this.props.user.dogs;

    return dogs && dogs.length;
  }

  canAddPooch() {
    const userIsOwner = this.props.user.subscription === 'Owner';

    if (!userIsOwner || (this.props.user.dogs && this.props.user.dogs.length >= 4)) {
      // Maximum of 4 dogs can be added
      return false;
    }

    return true;
  }

  hasUnpublishedProfiles() {
    if (!this.props.user.published) {
      return true;
    }

    return this.props.user.dogs &&
    this.props.user.dogs.find(dog => !dog.published);
  }

  toggleMenu(e, preventDefault) {
    if (preventDefault) e.preventDefault();

    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  }

  renderImage() {
    // if (this.getHasDogs()) {
    //   const firstDog = this.props.user.dogs[0];
    //   return (
    //     <Link to={`/pooch/${firstDog.id}`} onClick={Theme.isMobile ? e =>
    //             this.toggleMenu(e, true) : null}>
    //       <UserImage styles={styles.profile_image} image={this.getDogImage(firstDog)} />
    //     </Link>
    //   );
    // }

    return (
      <Link to={`/profile/${this.props.user.id}`} onClick={Theme.isMobile ? e => this.toggleMenu(e, true) : null}>
        <UserImage styles={styles.profile_image} image={this.getUserImage()} />
      </Link>
    );
  }

  renderDogs() {
    return this.getHasDogs() ? this.props.user.dogs.map(dog => (
      <Profile
        id={dog.id}
        name={dog.name}
        dog
        published={dog.published}
        image={this.getDogImage(dog)}
        callback={Theme.isMobile ? this.toggleMenu : null} />
    )) : false;
  }

  render() {
    return (
      <div
        className={css(styles.profile_container, this.state.menuOpen ? styles.container_top : null) + ' SVGContainer SettingsSVG'}
        onMouseEnter={!Theme.isMobile && !this.state.menuOpen ? this.toggleMenu : null}
        onMouseLeave={!Theme.isMobile && this.state.menuOpen ? this.toggleMenu : null}>
        {Theme.isMobile && this.state.menuOpen ?
          <div className={css(styles.close)} onClick={this.toggleMenu} role="button" tabIndex={0} />
        : null}
        <div className={css(styles.profile_bubble)}>
          {
            this.renderImage()
          }
          {
            this.hasUnpublishedProfiles() ? (
              <div className={css(styles.label)}>New</div>
            ) : false
          }
        </div>
        <ul className={css(styles.profile_menu, this.state.menuOpen ? styles.menu_open : null)}>
          <Profile
            id={this.props.user.id}
            name={this.props.user.display_name ?
              this.props.user.display_name : this.props.user.first_name}
            dog={false}
            published={this.props.user.published}
            image={this.getUserImage()}
            callback={Theme.isMobile ? this.toggleMenu : null} />
          {
            this.renderDogs()
          }
          {
            this.canAddPooch() ? (
              <li>
                <NavLink to="/join/pooch" className={css(styles.profile_add)}>
                  Add {
                    this.props.user.dogs && this.props.user.dogs.length > 0 ? 'another' : 'a'
                  } Pooch
                </NavLink>
              </li>
            ) : false
          }
        </ul>
      </div>
    );
  }
}

UserMenu.propTypes = {
  user: PropTypes.object.isRequired,
  // dispatch: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  close: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    content: '""',
  },
  container_top: {
    zIndex: 9,
  },
  profile_container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: Theme.navigation.height,
    marginLeft: 20,
    marginRight: 15,

    [Theme.mobile_query]: {
      position: 'static',
      marginLeft: 10,
      marginRight: 5,
    },
  },
  profile_bubble: {
    position: 'relative',
  },
  label: {
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    right: -18,
    height: 18,
    padding: '0 7px 0 8px',
    color: '#fff',
    fontSize: 10,
    fontFamily: Theme.font_family_secondary,
    fontWeight: 900,
    lineHeight: '18px',
    letterSpacing: 1.4,
    textAlign: 'center',
    textTransform: 'uppercase',
    borderRadius: 4,
    backgroundColor: '#39b4d6',

    [Theme.mobile_query]: {
      bottom: -6,
      right: 'calc(50% - 22px)',
    },
  },

  profile_image: {
    marginLeft: 0,
    marginRight: 0,
  },
  menu_open: {
    transform: 'rotate(0deg)',
    opacity: 1,
    pointerEvents: 'initial',
  },

  profile_menu: {
    position: 'absolute',
    top: '100%',
    right: -10,
    width: 385,
    color: Theme.white,
    backgroundColor: '#021a36',
    opacity: 0,
    transform: 'rotateX(-100deg)',
    transformOrigin: 'top center',
    transition: 'all 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275)',
    pointerEvents: 'none',

    [Theme.mobile_query]: {
      right: 0,
      width: '100vw',
    },
  },

  profile_add: {
    display: 'block',
    height: 60,
    lineHeight: '60px',
    textAlign: 'center',
    fontFamily: Theme.font_family_secondary,
    fontSize: 15,
    fontWeight: Theme.font_weight_secondary,
    letterSpacing: 2,
    color: '#39b4d6',
    textTransform: 'uppercase',
    backgroundColor: Theme.white,
    transition: 'all 300ms',

    ':hover': {
      color: Theme.white,
      backgroundColor: '#39b4d6',
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/UserMenu/index.js